module.exports = __webpack_public_path__ + "static/media/notification.98a6d9ee.mp3";